<ion-button routerDirection="backward" (click)="goBack()">
  <ion-icon slot="start" name="arrow-back"></ion-icon>
</ion-button>